import CompanyTable from "/src/features/administration/company/components/CompanyTable/CompanyTable";
function CompanyList() {
    return <CompanyTable/>
}

export default CompanyList;